<template>
    <div class="performance-list">
        <div
            v-for="(perf, topic) in topicsPerformance"
            :key="topic"
            class="performance-item"
        >
            <div class="perf-header">
                <span class="perf-topic">{{ getTopicLabel(topic) }}</span>
                <span class="perf-accuracy">{{ perf.accuracy.toFixed(1) }}%</span>
            </div>
            <div class="perf-details">
                <span>{{ perf.correct }}/{{ perf.attempts }} correct</span>
                <span>Avg: {{ perf.average_score.toFixed(2) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { getTopicLabel } from '@/utils/topicHelpers';

export default {
    name: 'PerformanceQuickView',
    props: {
        topicsPerformance: {
            type: Object,
            required: true
        }
    },
    setup() {
        return {
            getTopicLabel
        };
    }
};
</script>

<style scoped>
.performance-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.performance-item {
    padding: 20px;
    background: var(--bg-primary);
    border: 1px solid rgba(var(--accent-rgb), 0.4);
    transition: all 0.3s;
}

.performance-item:hover {
    border-color: var(--accent);
    background: var(--bg-secondary);
    transform: translateX(5px);
}

.perf-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.perf-topic {
    color: var(--text-primary);
    font-weight: 600;
    font-size: 18px;
}

.perf-accuracy {
    color: var(--text-secondary);
    font-weight: 700;
    font-size: 24px;
}

.perf-details {
    display: flex;
    gap: 20px;
    color: var(--text-primary);
    font-size: 14px;
    opacity: 0.8;
}
</style>